export default "__VITE_ASSET__G0typYm6__"